<div class="fade modal modal-static pg-show-modal" [id]="modalName" tabindex="-1" role="dialog" aria-hidden="true"
    data-backdrop="static" data-pg-collapsed>
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" *ngIf="isLoadingPage===false">{{_id > 0?'Edición de ':'Creación de '}}usuario
                </h4>
                <button type="button" class="close" (click)="closeModal()" aria-hidden="true"
                    title="Cerrar modal">&times;</button>
            </div>
            <div class="modal-body">
                <form [formGroup]="_formGroupModal" class="needs-validation">
                    <div [id]="carouselName" class="carousel slide" data-interval="false" data-keyboard="false">
                        <div class="carousel-inner no-padding transition-carousel-inner">

                            <div class="loading-ctn" *ngIf="isLoadingPage">
                                <svg version="1.1" id="loader-pj-1" xmlns="http://www.w3.org/2000/svg" class="icon"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
                                    enable-background="new 0 0 40 40" xml:space="preserve">
                                    <path opacity="0.12" fill="#003def"
                                        d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                            s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                            c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
                                    <path fill="#003def" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                            C22.32,8.481,24.301,9.057,26.013,10.047z">
                                        <animateTransform attributeName="transform" attributeType="XML" type="rotate"
                                            from="0 20 20" to="360 20 20" dur="1.5s" repeatCount="indefinite" />
                                    </path>
                                </svg>
                            </div>

                            <div class="carousel-item active" [class.d-none]="isLoadingPage === true">
                                <div class="alert alert-light font-size-13 no-padding text-dark mgn-top-5"
                                    *ngIf="_id === 0 && institutions.length === 1">
                                    A continuación podrás crear nuevos usuarios. Deberás determinar el tipo de perfil,
                                    según sus privilegios.
                                </div>
                                <div class="alert alert-light font-size-13 no-padding text-dark mgn-top-5"
                                    *ngIf="_id === 0 && institutions.length > 1">
                                    A continuación podrás crear nuevos usuarios. Deberás determinar el tipo de perfil
                                    (según sus privilegios), así como las instituciones para las cuales el perfil tendrá
                                    incidencia.
                                </div>
                                <small class="form-text mgn-bottom-10 text-muted text-right">* Campos
                                    obligatorios</small>
                                <fieldset class="mgn-bottom-25">
                                    <legend class="accesibleHidden">Datos del usuario</legend>
                                    <div class="form-row">
                                        <div class="col-12 col-sm-6">
                                            <form-group-text [control]="userName" [id]="'input-name-user'"
                                                [title]="'Nombres'" [maxlength]="100"
                                                [placeholder]="'Ingresa sus nombres'"
                                                [messageRequired]="'Nombres son requeridos.'">
                                            </form-group-text>
                                        </div>

                                        <div class="col-12 col-sm-6">
                                            <form-group-text [control]="userSurname" [id]="'input-surname-user'"
                                                [title]="'Apellidos'" [maxlength]="100"
                                                [placeholder]="'Ingresa sus apellidos'"
                                                [messageRequired]="'Apellidos son requeridos.'">
                                            </form-group-text>
                                        </div>

                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label id="teacher-rut-label" for="input-DNI">RUT (*)</label>
                                                <input id="input-DNI" type="text" class="form-control"
                                                    placeholder="Ej. 9000999-1" maxlength="12" name="userDNI"
                                                    title="Edición RUT" formControlName="userDNI"
                                                    [ngClass]="{'is-invalid':userDNI.touched && userDNI.invalid}" />
                                                <div class="invalid-feedback"
                                                    *ngIf="userDNI.touched && userDNI.invalid">
                                                    <div *ngIf="userDNI.errors.required">RUT es requerido.</div>
                                                    <div *ngIf="userDNI.errors.invalidRut">Rut ingresado no es
                                                        válido.</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 col-sm-6">
                                            <form-group-text [control]="userEmail" [id]="'employer-pass-recovery-input'"
                                                [title]="'Email'" [placeholder]="'Ingrese su email'"
                                                [messageRequired]="'Email es requerido.'"
                                                [messagePattern]="'El email ingresado no tiene un formato valido.'">
                                            </form-group-text>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <form-group-phone [control]="userPhoneNumber" [id]="'input-phoneNumber'"
                                                [title]="'Número celular'" [placeholder]="'Ingresa ocho dígitos'"
                                                [messageRequired]="'Número celular es requerido.'">
                                            </form-group-phone>
                                        </div>
                                         
                                        <div class="col-12" *ngIf="institutions.length > 1">
                                            <form-group-checkbox-multi #inputInstitution [id]="modalName + 'institution'"
                                                [title]="'Instituciones sobre las que tendrá privilegios'"
                                                [textSelectAllGroup]="'Seleccionar todo'"
                                                [showValuesOnPlaceholder]="true" [placeholder]="'Seleccione'"
                                                [placeholderSearch]="'Buscar institución'"
                                                [dataSelectLabel]="institutions" [controlArray]="optionInstitution"
                                                [enabledFilter]="true"
                                                [footer]="'Puedes seleccionar 1 o más opciones. También puedes escribir para buscar rápidamente.'">
                                            </form-group-checkbox-multi>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <div class="form-group required">
                                                <span class="label">Perfil</span>
                                                <small *ngIf="!selectedRole"
                                                    class="form-text text-danger mgn-bottom-10">El Perfil es
                                                    requerido. Selecciona una opción.</small>
                                                <div
                                                    class="border-radius-lg overflow-auto table-responsive table-max-height-75-vh">
                                                    <table
                                                        class="table table-megenta-header-1 table-sticky-head-2-col table-vertical-align-middle text-center mgn-bottom-0">
                                                        <thead>
                                                            <tr>
                                                                <th><span class="accesibleHidden">Módulo</span></th>
                                                                <th><span class="accesibleHidden">Función</span></th>
                                                                <ng-container
                                                                    *ngFor="let role of userRoles; let i = index">
                                                                    <th>

                                                                        <ng-template appHasAccessInterview
                                                                            [userProfile]="role"
                                                                            [hasCreditsInterview]="hasCreditsInterview || _id === _idCurrentUser"
                                                                            [appHasAccessInterviewElse]="elseBlock">
                                                                            <label *ngIf="_id !== _idCurrentUser"
                                                                                class="radio-label"
                                                                                [for]="'user-privileges-' + (i + 1)">
                                                                                <input type="radio"
                                                                                    [id]="'user-privileges-' + (i + 1)"
                                                                                    formControlName="userRole"
                                                                                    name="userRole" [value]="role"
                                                                                    (change)="onRoleChange(role)"
                                                                                    required>
                                                                                <span class="radiomark"></span>
                                                                                {{ role | roleName }}
                                                                            </label>

                                                                            <label *ngIf="_id === _idCurrentUser"
                                                                                class="radio-label"
                                                                                data-toggle="popover"
                                                                                data-placement="top"
                                                                                data-trigger="hover" data-html="true"
                                                                                data-content="No es posible editar tu propio perfil.">
                                                                                <input type="radio"
                                                                                    [id]="'user-privileges-' + (i + 1)"
                                                                                    name="userRole" [value]="role"
                                                                                    formControlName="userRole"
                                                                                    (change)="onRoleChange(role)"
                                                                                    disabled>
                                                                                <span class="radiomark"></span>
                                                                                {{ role | roleName }}
                                                                            </label>
                                                                        </ng-template>
                                                                        <ng-template #elseBlock>

                                                                            <a role="button"
                                                                                (click)="onClickContactForm($event)"
                                                                                data-toggle="popover"
                                                                                data-placement="top" data-html="true"
                                                                                data-trigger="hover"
                                                                                data-content="Haz click aquí para activar Evaluaciones Psicolaborales"
                                                                                class="mgn-rigth-3">
                                                                                <label
                                                                                    class=" radio-label disabled-status-icon disabled">
                                                                                    <input type="radio" name="userRole">
                                                                                    <span class="radiomark"></span>
                                                                                    {{ role | roleName }}
                                                                                </label>
                                                                            </a>


                                                                        </ng-template>
                                                                    </th>
                                                                </ng-container>
                                                            </tr>
                                                        </thead>
                                                        <!-- Cuerpo de la tabla con información detallada -->
                                                        <tbody #userPrivilegesInfo id="user-privileges-info"
                                                            class="collapse">
                                                            <!-- Iteración sobre los detalles de privilegios -->
                                                            <ng-container *ngFor="let module of privilegesDetails">
                                                                <ng-container *ngIf="module.functions.length > 0">
                                                                    <ng-container
                                                                        *ngFor="let func of module.functions; let isFirstRow = first">
                                                                        <tr>
                                                                            <ng-container *ngIf="isFirstRow">
                                                                                <th [attr.rowspan]="calculateRowspan(module)"
                                                                                    scope="row">{{ module.module }}</th>
                                                                            </ng-container>
                                                                            <th scope="row">{{ func.name }}</th>
                                                                            <!-- Iteración sobre los accesos correspondientes a cada función -->
                                                                            <td *ngFor="let roleIndex of [0, 1, 2, 3]">
                                                                                <span class="accesibleHidden">{{
                                                                                    func.access[roleIndex] ? 'Si' : 'No'
                                                                                    }}</span>
                                                                                <i class="pj-ico pj-ico-checks text-primary"
                                                                                    *ngIf="func.access[roleIndex]"></i>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                </ng-container>
                                                            </ng-container>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div class="mgn-top-10 mgn-bottom-10 text-center">
                                                <button type="button" (click)="togglePrivilegesInfo(isCollapsed)"
                                                    class="btn btn-link btn-xs-2 icon-chevron-right">
                                                    {{ buttonLabel }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <div class="form-row">
                                    <div class="col-12 text-center">
                                        <div class="text-center space-items-15">
                                            <button class="btn btn-outline-primary btn-block-xs" (click)="closeModal()"
                                                type="button">Cancelar</button>
                                            <button class="btn btn-primary btn-block-xs" type="submit"
                                                [attr.disabled]="_formGroupModal.valid === true ? null : true"
                                                (click)='validateStepData()'>Continuar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="carousel-item">

                                <div
                                    class="alert alert-light font-size-13 mgn-bottom-25 no-padding text-dark mgn-top-5">
                                    ¿Está
                                    seguro que desea crear un nuevo usuario según las siguientes características?
                                </div>
                                <div class="detail-main-content">
                                    <h4 class="detail-title">Nombres y apellidos</h4>
                                    <p>{{userName.value}} {{userSurname.value}}</p>
                                </div>
                                <div class="detail-main-content">
                                    <h4 class="detail-title">RUT</h4>
                                    <p>{{userDNI.value}}</p>
                                </div>
                                <div class="detail-main-content">
                                    <h4 class="detail-title">Email</h4>
                                    <p>{{userEmail.value}}</p>
                                </div>
                                <div class="detail-main-content">
                                    <h4 class="detail-title">Número de celular</h4>
                                    <p>+569{{userPhoneNumber.value}}</p>
                                </div>
                                <div class="detail-main-content"
                                    *ngIf="institutions.length > 1 && institutionSelected.length > 0">
                                    <h4 class="detail-title">Institución</h4>
                                    <p>{{institutionSelected | arraySeparator}}</p>
                                </div>
                                <div class="detail-main-content">
                                    <h4 class="detail-title">Perfil</h4>
                                    <p>{{userRole.value | roleName}}</p>
                                </div>
                                <div class="form-row">
                                    <div class="col-12">
                                        <div
                                            class="d-flex flex-column-reverse flex-sm-row justify-content-sm-center space-items-10">
                                            <div>
                                                <button class="btn btn-outline-primary back-step-btn btn-block-xs"
                                                    type="button" (click)="prevStepCarousel()">Atrás</button>
                                            </div>
                                            <div>
                                                <button [attr.disabled]="isLoadingRequest === true ? true : null"
                                                    class="btn btn-block-xs btn-primary" type="submit"
                                                    (click)="addUser($event)">{{_id > 0 ? 'Guardar' : 'Crear'}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item successSlide">
                                <div class="mgn-bottom-25 row">
                                    <div class="col-12 text-center"><i
                                            class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico pj-ico-modal-ok"></i>
                                        <p class="mgn-bottom-25 text-dark">Los datos se guardaron exitosamente.</p>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">
                                        <button class="btn btn-primary btn-block-xs" (click)="closeModal()"
                                            type="button">Cerrar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item errorSlide">
                                <div class="mgn-bottom-25 row">
                                    <div class="col-12 text-center"><i
                                            class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico pj-ico-modal-error"></i>
                                        <h4 class="error-alert-heading text-primary">Lo sentimos, ha
                                            ocurrido un error</h4>

                                        <p *ngIf="errorMessage?.email > 0" class="text-dark">El email
                                            <strong>{{userEmail.value}}</strong> ya se encuentra registrado.
                                        </p>
                                        <p *ngIf="errorMessage?.dni > 0" class="text-dark">El rut
                                            <strong>{{userDNI.value}}</strong> ya se encuentra registrado.
                                        </p>

                                        <p class="mgn-bottom-25 text-dark">Presione el botón “Volver a intentar” para
                                            intentarlo otra vez.</p>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15"><a
                                            class="btn btn-primary btn-block-xs" role="button"
                                            (click)="resetStepCarousel()">Volver a intentar</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>